import LogAndFilesSidebar from './LogAndFilesSidebar';

export default LogAndFilesSidebar;
